import {getLocalizationBasedOnLang} from '../../../data/models/User/UserInfo';

const english = {
  title: 'Payment cancelled',
  subtitle1:
    'You’ve cancelled the checkout process or closed the payment window.',
  subtitle2:
    'Don’t worry - your workspace is safe, and you can complete the payment anytime.',
  whatsNext: 'What’s next?',
  cardText:
    'If you had any issues during payment, feel free to try again or contact our support team.',
  goToWorkspace: 'Go to workspace',
  goToSubscrioptions: 'Go to subscriptions',
};

const welsh = {
  title: 'Taliad wedi’i ganslo',
  subtitle1: 'Rydych wedi canslo’r broses dalu neu wedi cau’r ffenestr talu.',
  subtitle2:
    'Peidiwch â phoeni - mae eich gofod gwaith yn ddiogel, ac mae modd cwblhau’r taliad unrhyw bryd.',
  whatsNext: 'Beth nesaf?',
  cardText:
    'Os cawsoch unrhyw broblemau yn ystod y taliad, mae croeso i chi drio eto neu gysylltu â’n tîm cymorth.',
  goToWorkspace: 'Ewch i’r gofod gwaith',
  goToSubscrioptions: 'Ewch i danysgrifiadau',
};

export const SubscriptionCancelText: any = getLocalizationBasedOnLang(
  english,
  welsh,
);
